
import { useState, useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useProjectData = (urlProjectId: string | null) => {
  const [projectName, setProjectName] = useState<string>("");
  const [selectedStructure, setSelectedStructure] = useState<string>("");
  const [directorsCount, setDirectorsCount] = useState(1);
  const [managersCount, setManagersCount] = useState(1);
  const [teamMembersCount, setTeamMembersCount] = useState(1);
  const [isEditable, setIsEditable] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertDescription, setAlertDescription] = useState("");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (!urlProjectId) {
        setAlertTitle("Error Loading Data");
        setAlertDescription("Please select a project first");
        setIsError(true);
        setShowAlert(true);
        return;
      }

      try {
        const { data: projectData, error: projectError } = await supabase
          .from('project_requirements')
          .select('*')
          .eq('id', urlProjectId)
          .maybeSingle();

        if (projectError) {
          console.error('Error fetching project data:', projectError);
          throw projectError;
        }

        if (!projectData) {
          throw new Error('No project data found');
        }

        setProjectName(projectData.name || '');
        setSelectedStructure(projectData.organizational_structure || '');
        setDirectorsCount(projectData.directors_count);
        setManagersCount(projectData.managers_count);
        setTeamMembersCount(projectData.team_members_count);

        const { data: structureData, error: structureError } = await supabase
          .from('organization_structures')
          .select('*')
          .eq('project_id', projectData.project_id)
          .maybeSingle();

        if (structureError) {
          console.error('Error fetching organization structure:', structureError);
          throw structureError;
        }

        setIsEditable(structureData?.is_editable !== false);

        return { projectData, structureData };
      } catch (error) {
        console.error('Error in fetchProjectDetails:', error);
        setAlertTitle("Error Loading Data");
        setAlertDescription("An unexpected error occurred while fetching project details");
        setIsError(true);
        setShowAlert(true);
        return null;
      }
    };

    fetchProjectDetails();
  }, [urlProjectId]);

  return {
    projectName,
    selectedStructure,
    directorsCount,
    managersCount,
    teamMembersCount,
    isEditable,
    setIsEditable,
    showAlert,
    setShowAlert,
    alertTitle,
    alertDescription,
    isError
  };
};
